module.exports = __webpack_public_path__ + "media/gus-teja-awan-putih.741a0307.mp3";